import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBx3NfcEF7MQZc7UwigiDiy9AYl3IJYPOU",
  authDomain: "learnable-d0b0e.firebaseapp.com",
  projectId: "learnable-d0b0e",
  storageBucket: "learnable-d0b0e.firebasestorage.app",
  messagingSenderId: "832662952007",
  appId: "1:832662952007:web:50be78abf54ee38ce2f962"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
